import { render, staticRenderFns } from "./menuTag.vue?vue&type=template&id=674a0437&scoped=true&"
import script from "./menuTag.vue?vue&type=script&lang=js&"
export * from "./menuTag.vue?vue&type=script&lang=js&"
import style0 from "./menuTag.vue?vue&type=style&index=0&id=674a0437&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a0437",
  null
  
)

export default component.exports